const splitCamelCase = (text) => text
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1-$2');

export const toTestId = (...parts) => parts
    .filter(part => part !== null && part !== undefined && part !== '')
    .map(part => splitCamelCase(String(part)))
    .join('-')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
